import { useEffect, useState } from "react"
import { FaCheck, FaInfoCircle, FaSearch } from "react-icons/fa"
import { MdChevronRight } from "react-icons/md"
import { PropTypes } from 'prop-types';
import { useDispatch, useSelector } from "react-redux";
import { fetchAllProgrammesData } from "../../redux/slice/allProgrammesPage";
import { useSearchParams } from "react-router-dom";

const ChooseCourse = ({ q }) => {

    const [searchParams, setSearchParams] = useSearchParams()

    const dispatch = useDispatch()
    const state = useSelector(state => state.allProgrammes)
    const [selectedCourse, setSelectedCourse] = useState(null)
    const [filteredData, setFilteredData] = useState([])
    const [search, setSearch] = useState("")
    const [degree, setDegree] = useState(-1)

    useEffect(() => {
        dispatch(fetchAllProgrammesData("/all-programmes?fields=properties%5B%24all%5D"))
    }, [dispatch])


    const programmes = state?.data?.properties?.colleges?.items?.map(item => {
        item = item?.content?.properties
        return {
            field: item?.collegeName?.name,
            courses: item?.courses?.map(course => course?.name)
        }
    })

    useEffect(() => {
        if (selectedCourse?.field) {
            getInterest(selectedCourse?.field)
        }
    }, [selectedCourse?.field])



    const getInterest = (collegeName) => {
        let interest = 0
        switch (collegeName) {
            case "College of Engineering":
                interest = 1
                break;
            case "UNITEN Business School (UBS)":
                interest = 2
                break;
            case "College of Computing & Informatics (CCI)":
                interest = 3
                break;


        }
        if (interest > 0) {
            setSearchParams(searchParams => {
                searchParams.set("interest", interest);
                return searchParams;
            });
        }

    }

   
    // const [date, setDate] = useState(-1)

    // const dates = [
    //     "Apr - Jun 24",
    //     "Jul - Sep 24",
    //     "Oct - Dec 24",
    //     "Jan - Mar 25",
    //     "Apr 25 onwards",
    // ]
    const degrees = [
        {
            name: "Foundation",
            isApplicable: searchParams.get("educationLevel") == 1,
            include: "",
            overview: [
                "3-4 years programme",
                "Learn in-depth about a field of study, and can specialize in a specific subject",
                "A higher qualification which enables access to higher level job entry positions"
            ],
        },
        {
            name: "International Pre-University",
            isApplicable: searchParams.get("educationLevel") == 1,
            include: "(incl A-level, IB Diploma, CPU, SACE)",
            overview: [
                "3-4 years programme",
                "Learn in-depth about a field of study, and can specialize in a specific subject",
                "A higher qualification which enables access to higher level job entry positions"
            ],
        },
        {
            name: "Diploma",
            isApplicable: searchParams.get("educationLevel") == 1,
            include: "",
            overview: [
                "3-4 years programme",
                "Learn in-depth about a field of study, and can specialize in a specific subject",
                "A higher qualification which enables access to higher level job entry positions"
            ],
        },
        {
            name: "Degree",
            isApplicable: searchParams.get("educationLevel") == 2,
            include: "",
            overview: [
                "3-4 years programme",
                "Learn in-depth about a field of study, and can specialize in a specific subject",
                "A higher qualification which enables access to higher level job entry positions"
            ],
        },
    ]



    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (search !== "") {
                setFilteredData(programmes?.map(programme => ({
                        field: programme?.field,
                        courses: programme?.courses?.filter(course =>
                            course?.toLowerCase()?.includes(search?.toLowerCase())
                        )
                    }))
                    .filter(programme => programme?.courses?.length > 0)
                );
            } else {
                setFilteredData([]);
                setSelectedCourse(null);
            }
        }, 500);

        return () => clearTimeout(timeoutId);
    }, [search]);


    const handleReset = () => {
        setSelectedCourse(null)
        setSearch("")
        setFilteredData([])
    }

    const handleDegree = (i) => {
        setDegree(i)
    }



    return (
        selectedCourse != null ?
            (
                q == 2 ?
                    <div className="flex flex-col gap-5">
                        <h1 className="flex items-center font-semibold text-xl gap-2">What is your preferred pathway for
                            <span className="text-[#679ac4]"> {selectedCourse.course}?</span>
                            <div className="flex items-center gap-1 text-red-500">
                                <FaInfoCircle size={25} />
                                <span>Pathways to Degree</span>

                            </div>
                        </h1>
                        <div className="flex flex-col md:flex-row flex-wrap gap-3 max-w-[90rem]">
                            {
                                degrees?.map((item, index) => (
                                    <button aria-label={item.include} key={index} onClick={() => handleDegree(index)} disabled={!item.isApplicable} className={`flex-1 flex flex-col items-center justify-center font-medium  ${!item.isApplicable ? "bg-[#eef3f6]" : degree === index ? "bg-[#367AB1] text-white" : "bg-white "} transition-all border border-gray-200 p-4 rounded-lg whitespace-pre-line`}>
                                        {item.name}
                                        {
                                            item.include && <span>{item.include}</span>
                                        }
                                        {
                                            item.isApplicable == false &&
                                            <span className="italic">Not Applicable</span>
                                        }
                                    </button>
                                )
                                )
                            }


                        </div>
                        {
                            degree != -1 &&
                            <div className="flex flex-col gap-3 max-w-3xl bg-[#e5f1f8] font-medium p-4">
                                <h1 className="flex items-center gap-1"><span className="font-bold">{degrees[degree].name}</span>Overview</h1>
                                <ul className="flex flex-col gap-3">
                                    {
                                        degrees[degree]?.overview?.map((i, index) =>
                                            <li className="flex items-center gap-3 " key={index}>
                                                <div className="w-5 h-5 p-1   rounded-full grid place-items-center bg-[#367AB1] text-white">
                                                    <FaCheck size={12} />
                                                </div>
                                                {i}</li>
                                        )
                                    }
                                </ul>
                            </div>
                        }
                        {/* <div className={`flex flex-col gap-5 mt-4 ${degree === -1 ? "opacity-30" : "opacity-100"} transition-all `}>
                            <h1 className="flex items-center font-semibold text-xl gap-2">When do you plan to start your studies?</h1>
                            <div className="flex flex-col md:flex-row flex-wrap gap-3 max-w-6xl">
                                {
                                    dates?.map((item, index) => (
                                        <button key={index} onClick={() => setDate(index)} disabled={degree === -1} className={`flex-1 flex flex-col items-center justify-center font-medium  ${date === index ? "bg-[#367AB1] text-white" : "bg-white "} transition-all border border-gray-200 p-4 py-5 rounded-lg whitespace-pre-line`}>
                                            {item}
                                        </button>
                                    )
                                    )
                                }


                            </div>
                        </div> */}
                    </div >
                    :
                    <div className="flex flex-col gap-3">
                        <h2 className="text-xl font-semibold uppercase">Your Selected Course</h2>
                        <div className="flex flex-col gap-3 max-w-3xl bg-[#e5f1f8] p-4">
                            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                                <span className="font-medium">Course:</span>
                                <span className="flex-1 sm:max-w-[70%] p-4 bg-[#027bb6] text-white px-5  font-medium rounded-md">{selectedCourse.course}</span>
                            </div>
                            <div className="flex flex-col sm:flex-row sm:items-center  justify-between gap-2">
                                <span className="font-medium">Field of Study:</span>
                                <span className="flex-1 sm:max-w-[70%] p-4 bg-[#027bb6] text-white px-5  font-medium rounded-md">{selectedCourse.field}</span>
                            </div>
                            <div className="flex items-center justify-end">
                                <button aria-label="changeCourse" onClick={handleReset} className=" text-red-500 font-bold text-lg border-none outline-none">Change Course</button>
                            </div>
                        </div>
                    </div>
            )
            :
            <div className="flex flex-col gap-5">
                <h2 className="text-xl font-semibold">What is your preferred course?</h2>
                <div className="flex items-center gap-3 border max-w-xl border-[#D8E2E9] p-4 rounded-lg   outline-none">
                    <FaSearch size={20} />
                    <input
                        type="text"
                        placeholder="Search Course"
                        className="border-none outline-none w-full placeholder:text-[#FFA18F] text-lg text-[#8C1600]"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
                {

                    filteredData?.length > 0 &&
                    <div className="flex flex-col gap-10">
                        <div className="flex flex-col gap-3">
                            <h2 className="text-xl font-semibold uppercase">Suggested Course</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 max-w-6xl">
                                {
                                    filteredData?.map((d, i) => (
                                        d?.courses?.map(course =>
                                            <button
                                                name={d.field}
                                                key={i}
                                                onClick={() => setSelectedCourse(
                                                    {
                                                        course: course,
                                                        field: d.field
                                                    }
                                                )}
                                                className={`flex-1 flex items-center justify-between ${selectedCourse?.course === course ? "border-[#679ac4]" : "border-[#D8E2E9]"} transition-all border  p-4 rounded-lg whitespace-pre-line`}
                                            >
                                                <div className="flex flex-1 flex-col items-start gap-2">
                                                    <span className="text-[#8a2a2b]">{course}</span>
                                                    <p>See full list of courses</p>
                                                </div>
                                                <div className="flex items-center justify-center">
                                                    <MdChevronRight size={25} />
                                                </div>
                                            </button>
                                        )
                                    ))
                                }
                            </div>
                        </div>
                        <div className="flex flex-col gap-3">
                            <h2 className="text-xl font-semibold uppercase">Suggested Field of Study</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 max-w-6xl">
                                {
                                    filteredData?.map((d, i) => (
                                        <button
                                            name={d.field}
                                            key={i}
                                            onClick={() => setSelectedCourse(
                                                d
                                            )}
                                            className={`flex-1 flex items-center justify-between ${selectedCourse?.field === d.field ? "border-[#679ac4]" : "border-[#D8E2E9]"} transition-all border  p-4 rounded-lg whitespace-pre-line`}
                                        >
                                            <div className="flex flex-1 flex-col items-start gap-2">
                                                <span className="text-[#8a2a2b]">{d.field}</span>
                                                <p>See full list of courses</p>
                                            </div>
                                            <div className="flex items-center justify-center">
                                                <MdChevronRight size={25} />
                                            </div>

                                        </button>
                                    ))
                                }
                            </div>
                        </div>
                    </div>

                }
            </div>
    )
}
ChooseCourse.propTypes = {
    q: PropTypes.any
}
export default ChooseCourse